import { DateTime } from 'luxon';
import { FlowExecutionState } from '../../enums/flow-execution-state';
import { IntegrationStage } from '../../enums/integration-stage';
import { ObjectState } from '../../enums/objectState.enum';
import { SimulationState } from '../../enums/simulation/simulation-state';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { FlowType } from '../../types/flow-types';
import { Guid } from '../guid';

export class ExecutionHistory implements IConfigObjectBase {
	id = Guid();
	name = '';
	description?: string;
	dateCreated = DateTime.now();
	lastUpdated = DateTime.now();
	objectState?: ObjectState;
	taskExecutionState: { [key: string]: SimulationState } = {};
	flowType?: FlowType;
	flowID?: string;
	flowStage: IntegrationStage = IntegrationStage.Develop;
	executionID?: string;
	executionState = FlowExecutionState.PendingExecution;
	isSimulation = false;
	error = '';
	flowVersion = '';
	iHubVersion = '';
	projectSpaceID = '';
	clientSpaceID = '';

	constructor(executionHistoryProps?: Partial<ExecutionHistory>) {
		if (executionHistoryProps) {
			Object.assign(this, executionHistoryProps);
		}
	}
}
